import React, { createContext, useContext } from 'react'
import { Divider, Table, Button, Icon } from 'semantic-ui-react'
import Swal from 'sweetalert2'
import styles from './asset-view.module.css'
import AssetActions from './asset-actions'
import IntelMsg from '../../ItelMsg'
import { UnassignDevice } from '../../../services/asset'

export const AssetViewContext = createContext()

const AssetView = () => {
  const { setViewAsset, assetData, setAssetData } = useContext(AssetViewContext)
  const goBack = () => {
    setViewAsset(false)
  }

  console.log('asset: ', assetData)
  const vehicleAssetAttributes = () => {
    const vehicleAttributes = Object.keys(assetData).map((key) =>
      key.includes('vehicleAssetAttributes') ? { ...assetData[key] } : null,
    )
    return vehicleAttributes.map((el) => {
      if (el) {
        return Object.keys(el).map((key, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <Table.Row key={idx}>
            <Table.Cell
              width={3}
              style={{
                textTransform: 'capitalize',
                backgroundColor: '#d8e7ea',
              }}
            >
              {key === 'name' ? 'Asset Name' : key}
            </Table.Cell>
            <Table.Cell>{el[key]}</Table.Cell>
          </Table.Row>
        ))
      }
      return null
    })
  }
  const generateGeneralAttrs = () => {
    const general = Object.keys(assetData).map((key) =>
      key.includes('attributes') ? { ...assetData[key] } : null,
    )

    return general.map((el) => {
      if (el) {
        return Object.keys(el).map((key, idx) => {
          if (
            key === 'storage category' ||
            key === 'storage code' ||
            key === 'storage type'
          )
            return null

          return (
            // eslint-disable-next-line react/no-array-index-key
            <Table.Row key={idx}>
              <Table.Cell
                width={3}
                style={{
                  textTransform: 'capitalize',
                  backgroundColor: '#d8e7ea',
                }}
              >
                {key === 'name' ? 'Asset Name' : key}
              </Table.Cell>
              {key === 'photo' ? (
                <Table.Cell>
                  <img
                    style={{ width: '300px', height: '200px' }}
                    src={el[key]}
                    alt="Red dot"
                  />
                </Table.Cell>
              ) : (
                <Table.Cell>{el[key]}</Table.Cell>
              )}
            </Table.Row>
          )
        })
      }
      return null
    })
  }

  const generateStorageAttrs = () => (
    <>
      <Table.Row>
        <Table.Cell
          width={3}
          style={{ textTransform: 'capitalize', backgroundColor: '#d8e7ea' }}
        >
          storage type
        </Table.Cell>
        <Table.Cell style={{ textTransform: 'capitalize' }}>
          {assetData['general attributes']['storage type']}
        </Table.Cell>
      </Table.Row>

      <Table.Row>
        <Table.Cell
          width={3}
          style={{ textTransform: 'capitalize', backgroundColor: '#d8e7ea' }}
        >
          storage category
        </Table.Cell>
        <Table.Cell style={{ textTransform: 'capitalize' }}>
          {assetData['general attributes']['storage category']}
        </Table.Cell>
      </Table.Row>

      <Table.Row>
        <Table.Cell
          width={3}
          style={{ textTransform: 'capitalize', backgroundColor: '#d8e7ea' }}
        >
          storage code
        </Table.Cell>
        <Table.Cell style={{ textTransform: 'capitalize' }}>
          {assetData['general attributes']['storage code']}
        </Table.Cell>
      </Table.Row>
    </>
  )

  const generateHeaders = (name) => (
    <Table definition style={{ margin: '0' }}>
      <Table.Row style={{ backgroundColor: '#4B6587' }}>
        <Table.Cell style={{ padding: '2px' }}>
          <Divider style={{ color: 'white' }} horizontal>
            {name}
          </Divider>
        </Table.Cell>
      </Table.Row>
    </Table>
  )

  const generateDevices = () => (
    <>
      <Table.Header style={{ backgroundColor: 'rgb(216, 231, 234)' }}>
        <Table.Row>
          <Table.HeaderCell style={{ textAlign: 'center', padding: '6px' }}>
            Device Name
          </Table.HeaderCell>
          <Table.HeaderCell style={{ textAlign: 'center', padding: '6px' }}>
            Device Type
          </Table.HeaderCell>
          <Table.HeaderCell style={{ textAlign: 'center', padding: '6px' }}>
            Actions
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {assetData.devices && assetData.devices.length > 0 ? (
          assetData.devices.map((device, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <Table.Row key={idx}>
              <Table.Cell style={{ width: '33.33%', textAlign: 'center' }}>
                {device.label || device.name}
              </Table.Cell>

              <Table.Cell style={{ width: '33.33%', textAlign: 'center' }}>
                {device.type}
              </Table.Cell>

              <Table.Cell style={{ width: '33.33%', textAlign: 'center' }}>
                <Button
                  icon
                  color="red"
                  labelPosition="left"
                  onClick={() => handleUnAssign(device, assetData.assetId)}
                >
                  <Icon name="trash" />
                  Unassign
                </Button>
              </Table.Cell>
            </Table.Row>
          ))
        ) : (
          <Table.Row style={{ textAlign: 'center' }}>
            <br />
            <p>
              {' '}
              <b>No Devices To Show</b>{' '}
            </p>
            <br />
          </Table.Row>
        )}
      </Table.Body>
    </>
  )

  const generateAssets = () => {
    if (assetData['related assets']) {
      const countries = assetData['related assets'].filter(
        (asset) => asset['asset type'].toLowerCase() === 'country',
      )

      const regions = assetData['related assets'].filter(
        (asset) => asset['asset type'].toLowerCase() === 'region',
      )

      const facilities = assetData['related assets'].filter(
        (asset) => asset['asset type'].toLowerCase() === 'facility',
      )
      return (
        <>
          <Table.Header style={{ backgroundColor: 'rgb(216, 231, 234)' }}>
            <Table.Row>
              <Table.HeaderCell style={{ textAlign: 'center', padding: '6px' }}>
                LEVEL
              </Table.HeaderCell>
              <Table.HeaderCell style={{ textAlign: 'center', padding: '6px' }}>
                NAME
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {countries.map((asset, idx) => (
              // eslint-disable-next-line react/no-array-index-key
              <Table.Row key={idx}>
                <Table.Cell
                  style={{
                    width: '50%',
                    textAlign: 'center',
                    textTransform: 'capitalize',
                  }}
                >
                  {asset['asset type']}
                </Table.Cell>
                <Table.Cell style={{ width: '50%', textAlign: 'center' }}>
                  {asset['asset label'] || asset['asset name']}
                </Table.Cell>
              </Table.Row>
            ))}

            {regions.map((asset, idx) => (
              // eslint-disable-next-line react/no-array-index-key
              <Table.Row key={idx}>
                <Table.Cell
                  style={{
                    width: '50%',
                    textAlign: 'center',
                    textTransform: 'capitalize',
                  }}
                >
                  {asset['asset type']}
                </Table.Cell>
                <Table.Cell style={{ width: '50%', textAlign: 'center' }}>
                  {asset['asset label'] || asset['asset name']}
                </Table.Cell>
              </Table.Row>
            ))}

            {facilities.map((asset, idx) => (
              // eslint-disable-next-line react/no-array-index-key
              <Table.Row key={idx}>
                <Table.Cell
                  style={{ textAlign: 'center', textTransform: 'capitalize' }}
                >
                  {asset['asset type']}
                </Table.Cell>
                <Table.Cell style={{ textAlign: 'center' }}>
                  {asset['asset label']}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </>
      )
    }
    return (
      <>
        <Table.Header style={{ backgroundColor: 'rgb(216, 231, 234)' }}>
          <Table.Row>
            <Table.HeaderCell style={{ textAlign: 'center', padding: '6px' }}>
              LEVEL
            </Table.HeaderCell>
            <Table.HeaderCell style={{ textAlign: 'center', padding: '6px' }}>
              NAME
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row style={{ textAlign: 'center' }}>
            <br />
            <p>
              {' '}
              <b style={{ marginRight: '35%' }}>No Hierarchy To Show</b>{' '}
            </p>
            <br />
          </Table.Row>
        </Table.Body>
      </>
    )
  }

  const handleUnAssign = async (device, assetId) => {
    console.log(assetId)
    console.log('device: ', device)
    Swal.showLoading()
    const res = await UnassignDevice(device.type, device.id, assetId)
    if (res.status === 200) {
      let newDevices = [...assetData.devices]
      newDevices = newDevices.filter((d) => d.id !== device.id)
      setAssetData((prevState) => ({ ...prevState, devices: newDevices }))
      Swal.fire({
        title: 'Device Unassigned Successfully',
        icon: 'success',
        confirmButtonColor: 'Green',
      })
    } else {
      Swal.fire({
        title: 'Error Unassigning Device',
        icon: 'error',
        confirmButtonColor: 'Red',
      })
    }
  }

  return (
    <div>
      <div className={styles.container}>
        <IntelMsg id="assetDetails" />
      </div>

      {generateHeaders('ASSET INFO')}
      <Table definition style={{ margin: '0' }}>
        {generateGeneralAttrs()}
        {vehicleAssetAttributes()}
        <Table.Row>
          <Table.Cell
            width={3}
            style={{
              textTransform: 'capitalize',
              backgroundColor: '#d8e7ea',
            }}
          >
            Assigned Configuration Template
          </Table.Cell>
          <Table.Cell>{assetData.templateName}</Table.Cell>
        </Table.Row>
      </Table>

      {generateHeaders('STORAGE INFO')}
      <Table definition style={{ margin: '0' }}>
        {generateStorageAttrs()}
      </Table>

      {generateHeaders('ASSET HIERARCHY')}
      <Table sortable compact celled basic style={{ margin: '0' }}>
        {generateAssets()}
      </Table>

      {generateHeaders('ASSIGNED DEVICES')}
      <Table sortable compact celled basic style={{ margin: '0' }}>
        {generateDevices()}
      </Table>
      <AssetActions
        onBackClick={() => {
          goBack()
        }}
      />
    </div>
  )
}

export default AssetView
